// extracted by mini-css-extract-plugin
export default {"container":"SessionIdle_container__LWLXr","header":"SessionIdle_header__-yblN","footer":"SessionIdle_footer__aGKnM","heading":"SessionIdle_heading__E4eJE"};